import directives from "./directives";

export default function registerDirectives(app) {
  for (const def of directives) {
    app.directive(def.Name, def.Definition);
  }

  return app;
}
